import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HeaderComponent } from './header.component';
import { BreadcrumbModule } from '@syncfusion/ej2-angular-navigations';
import { BreadCrumbsComponent } from 'src/app/core/bread-crumbs/bread-crumbs.component';
import { BreadCrumbsModule } from 'src/app/core/bread-crumbs/bread-crumbs.module';
import { LanguageSwitcherModule } from '../language-switcher/language-switcher.module';
import { OfflineApiListModule } from 'src/app/core/offline-api-list/offline-api-list.module';
import { ButtonModule } from '@syncfusion/ej2-angular-buttons';
import { NotificationsCenterModule } from '../notifications-center/notifications-center.module';



@NgModule({
  declarations: [
    HeaderComponent,
  ],
  imports: [
    CommonModule,
    BreadCrumbsModule,
    LanguageSwitcherModule,
    ButtonModule,
    OfflineApiListModule,
    NotificationsCenterModule
  ],
  exports:[HeaderComponent]
})
export class HeaderModule { }
